export const getPlacement = (dom, popWidth, popHeight, sign) => {
    switch (sign) {
        case "TL":
            return {
                pop: {
                    top: `${dom.offsetTop - popHeight - 10}px`,
                    left: `${dom.offsetLeft}px`,
                },
                arrow: {
                    top: `${dom.offsetTop - 15}px`,
                    left: `${dom.offsetLeft + 5}px`,
                }
            };
        case "TR":
            return {
                pop: {
                    top: `${dom.offsetTop - popHeight - 10}px`,
                    left: `${dom.offsetLeft + dom.offsetWidth - popWidth}px`,
                },
                arrow: {
                    top: `${dom.offsetTop - 15}px`,
                    left: `${dom.offsetLeft + dom.offsetWidth - 15}px`,
                }
            };
        case "TOP":
            return {
                pop: {
                    top: `${dom.offsetTop - popHeight - 10}px`,
                    left: dom.offsetWidth > popWidth ? `${dom.offsetLeft + Number((dom.offsetWidth - popWidth) / 2)}px` : `${dom.offsetLeft - Number((popWidth - dom.offsetWidth) / 2)}px`
                },
                arrow: {
                    top: `${dom.offsetTop - 15}px`,
                    left: dom.offsetWidth > popWidth ? `${dom.offsetLeft + Number(dom.offsetWidth / 2) - 5}px` : `${dom.offsetLeft + Number(dom.offsetWidth / 2) - 5}px`
                },
                arrowBefore: {
                    top: `${dom.offsetTop - 16}px`,
                    left: dom.offsetWidth > popWidth ? `${dom.offsetLeft + Number(dom.offsetWidth / 2) - 5}px` : `${dom.offsetLeft + Number(dom.offsetWidth / 2) - 5}px`
                },
            };
        case "LT":
            return {
                pop: {
                    top: `${dom.offsetTop}px`,
                    left: `${dom.offsetLeft - popWidth - 10}px`
                },
                arrow: {
                    top: `${dom.offsetTop + 5}px`,
                    left: `${dom.offsetLeft - 15}px`
                }
            };
        case "LB":
            return {
                pop: {
                    top: `${dom.offsetTop + dom.offsetHeight - popHeight}px`,
                    left: `${dom.offsetLeft - popWidth - 10}px`
                },
                arrow: {
                    top: `${dom.offsetTop + dom.offsetHeight - 10}px`,
                    left: `${dom.offsetLeft - 15}px`
                }
            };
        case "LEFT":
            return {
                pop: {
                    top: dom.offsetHeight > popHeight ? `${dom.offsetTop - Number((popHeight - dom.offsetHeight) / 2)}px` : `${dom.offsetTop + Number((dom.offsetHeight - popHeight) / 2)}px`,
                    left: `${dom.offsetLeft - popWidth - 10}px`
                },
                arrow: {
                    top: dom.offsetHeight > popHeight ? `${dom.offsetTop + Number(dom.offsetHeight / 2) - 5}px` : `${dom.offsetTop + Number(dom.offsetHeight / 2) - 5}px`,
                    left: `${dom.offsetLeft - 15}px`
                },
                arrowBefore: {
                    top: dom.offsetHeight > popHeight ? `${dom.offsetTop + Number(dom.offsetHeight / 2) - 5}px` : `${dom.offsetTop + Number(dom.offsetHeight / 2) - 5}px`,
                    left: `${dom.offsetLeft - 14}px`
                },
            };
        case "BL":
            return {
                pop: {
                    top: `${dom.offsetTop + dom.offsetHeight + 10}px`,
                    left: `${dom.offsetLeft}px`
                },
                arrow: {
                    top: `${dom.offsetTop + dom.offsetHeight + 6}px`,
                    left: `${dom.offsetLeft + 10}px`
                }
            };
        case "BR":
            return {
                pop: {
                    top: `${dom.offsetTop + dom.offsetHeight + 10}px`,
                    left: `${dom.offsetLeft + dom.offsetWidth - popWidth}px`
                },
                arrow: {
                    top: `${dom.offsetTop + dom.offsetHeight + 6}px`,
                    left: `${dom.offsetLeft + dom.offsetWidth - 15}px`
                }
            };
        case "BOTTOM":
            return {
                pop: {
                    top: `${dom.offsetTop + dom.offsetHeight + 10}px`,
                    left: dom.offsetWidth > popWidth ? `${dom.offsetLeft + Number((dom.offsetWidth - popWidth) / 2)}px` : `${dom.offsetLeft - Number((popWidth - dom.offsetWidth) / 2)}px`
                },
                arrow: {
                    top: `${dom.offsetTop + dom.offsetHeight + 6}px`,
                    left: dom.offsetWidth > popWidth ? `${dom.offsetLeft + Number(dom.offsetWidth / 2) - 5}px` : `${dom.offsetLeft + dom.offsetWidth - 5}px`
                },
                arrowBefore: {
                    top: `${dom.offsetTop + dom.offsetHeight + 5}px`,
                    left: dom.offsetWidth > popWidth ? `${dom.offsetLeft + Number(dom.offsetWidth / 2) - 5}px` : `${dom.offsetLeft + dom.offsetWidth - 5}px`
                },
            };
        case "RT":
            return {
                pop: {
                    top: `${dom.offsetTop}px`,
                    left: `${dom.offsetLeft + dom.offsetWidth + 10}px`
                },
                arrow: {
                    top: `${dom.offsetTop + 10}px`,
                    left: `${dom.offsetLeft + dom.offsetWidth + 6}px`
                }
            };
        case "RB":
            return {
                pop: {
                    top: `${dom.offsetTop + dom.offsetHeight - popHeight}px`,
                    left: `${dom.offsetLeft + dom.offsetWidth + 10}px`
                },
                arrow: {
                    top: `${dom.offsetTop + dom.offsetHeight - 15}px`,
                    left: `${dom.offsetLeft + dom.offsetWidth + 6}px`
                }
            };
        case "RIGHT":
            return {
                pop: {
                    top: dom.offsetHeight > popHeight ? `${dom.offsetTop - Number((popHeight - dom.offsetHeight) / 2)}px` : `${dom.offsetTop + Number((dom.offsetHeight - popHeight) / 2)}px`,
                    left: `${dom.offsetLeft + dom.offsetWidth + 10}px`
                },
                arrow: {
                    top: dom.offsetHeight > popHeight ? `${dom.offsetTop + Number(dom.offsetHeight / 2) - 5}px` : `${dom.offsetTop + Number(dom.offsetHeight / 2) - 5}px`,
                    left: `${dom.offsetLeft + dom.offsetWidth + 6}px`
                },
                arrowBefore: {
                    top: dom.offsetHeight > popHeight ? `${dom.offsetTop + Number(dom.offsetHeight / 2) - 5}px` : `${dom.offsetTop + Number(dom.offsetHeight / 2) - 5}px`,
                    left: `${dom.offsetLeft + dom.offsetWidth + 5}px`
                },
            };
        default:
            return {
                top: `${dom.offsetTop}px`,
                left: `${dom.offsetLeft}px`,
            };
    }
};
